var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C16.5523 12 17 12.4477 17 13V16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V13C3 12.4477 3.44772 12 4 12C4.55228 12 5 12.4477 5 13V15H15V13C15 12.4477 15.4477 12 16 12ZM11 3L10.999 9.176L12.2929 7.88289C12.6534 7.52241 13.2206 7.49468 13.6129 7.7997L13.7071 7.88289C14.0676 8.24338 14.0953 8.81061 13.7903 9.2029L13.7071 9.29711L10 13.0042L6.29289 9.29711C5.90237 8.90658 5.90237 8.27342 6.29289 7.88289C6.65338 7.52241 7.22061 7.49468 7.6129 7.7997L7.70711 7.88289L8.999 9.174L9 3H11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b57fe339.svg";
export { ForwardRef as ReactComponent };